<div class="analises_page" *ngIf="permission.canSeeAnalysis">
  <div class="header_search">
    <div class="title-page">
      <h3>Análise Gerente</h3>
    </div>
    <div class="content_search">
      <div class="new-demand">
        <button class="btn-back" type="btn" (click)="mostrarAnteriores()">{{anteriores ? 'Ocultar' : 'Mostrar'}} Anteriores</button>
      </div>
      <div class="new-project" *ngIf="permission.canCreateAnalysis">
        <a class="btn btn-primary" type="btn" [routerLink]="novo()">Nova Análise</a>
      </div>
    </div>
  </div>

  <div class="system-table table-container">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th class="text-center">Status</th>
            <th>Situação</th>
            <th class="text-center">Atualização</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of analises">
            <tr *ngIf="item?.last_one || this.anteriores">
              <td class="title status">
                <div *ngIf="item?.status1 && item?.status_name">
                  <span [innerHTML]="item?.status1"></span>
                  {{item?.status_name}}
                </div>
              </td>
              <td>
                <div [innerHTML]="item?.description"></div>
              </td>
              <td class="text-center">
                <div class="m-b-xs">{{item?.ctr_usu_atu_name}}</div>
                {{item?.ctr_dth_atu}}
              </td>
              <td>
                <div class="btn-icon" *ngIf="item?.last_one">
                  <a class="icon-table m-b-sm" [routerLink]="editar(item?.id)" *ngIf="!item?.projectBlocked || item?.canCreateAnalysis">
                    <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                  </a>
                  <span class="icon-table icon-red m-b-sm" (click)="confirmExcluir(item)" *ngIf="!item?.projectBlocked || item?.canCreateAnalysis">
                    <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                  </span>
                  <a class="icon-table icon-table-text" [routerLink]="novaDemanda()" [queryParams]="novaDemandaParams(item?.id)" *ngIf="item?.canDemand">
                    Nova demanda
                  </a>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!analises?.length" class="border-b-radius">
            <td colspan="4" class="text-center">Nenhuma Análise Gerente Cadastrada.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>
